import HeadingArt from './HeadingArt';

const SALES_MOBILES = ['09128700961', '09128700962', '09913790073', '09913790074'];
const phoneLabel = number => number.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3').replace(/\d/g, digit => '۰۱۲۳۴۵۶۷۸۹'[Number(digit)]);

const STORE_ADDRESS = 'تهران، سعادت‌آباد، بلوار شاهنامه، نرسیده به میدان بهرود، مرکز خرید پرواز، طبقهٔ همکف، پلاک ۲۰۶';
const MAP_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`مکعب، ${STORE_ADDRESS}`)}`;

function FooterArt({ name, size = 28 }) {
  const asset = { phone: '05-goal-phone', location: '01-goal-house' }[name];
  return asset ? <img className="qcf-art" src={`/qolak/pastel/optimized-v1/${asset}-128.webp`} width={size} height={size} alt="" aria-hidden="true" loading="lazy" decoding="async" /> : <HeadingArt name={name} size={size} />;
}

export default function QolakFooter({ onLogin, onRegister, onAdmin }) {
  const year = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric' }).format(new Date());
  return <footer className="qcl-footer qcf" aria-label="راهنما و اطلاعات مکعب">
    <div className="qcf-inner">
      <div className="qcf-intro">
        <div className="qcf-brand"><img src="/qolak/mokaab-persian-horizontal.svg" width="110" height="42" alt="مکعب" /><div><strong>قلک مکعب</strong><p>قدم‌های امروز، برای هدف‌های فردا.</p></div></div>
        <a className="qcf-top" href="#top"><FooterArt name="goal" />بالای صفحه</a>
      </div>
      <div className="qcf-columns">
        <nav className="qcf-group" aria-labelledby="qcf-path-title">
          <h2 id="qcf-path-title"><FooterArt name="goal" size={32} />مسیر شما</h2>
          <a href="#goal-planner"><FooterArt name="goal" />برنامهٔ پس‌انداز</a>
          <a href="#how"><FooterArt name="history" />قلک چطور کار می‌کنه؟</a>
          <a href="#kids"><FooterArt name="family" />مکعب کیدز</a>
          <a href="#faq"><FooterArt name="info" />پرسش‌های رایج</a>
        </nav>
        <nav className="qcf-group" aria-labelledby="qcf-account-title">
          <h2 id="qcf-account-title"><FooterArt name="wallet" size={32} />حساب و مکعب</h2>
          <button type="button" onClick={onLogin}><FooterArt name="wallet" />ورود به حساب</button>
          <button type="button" onClick={onRegister}><FooterArt name="person" />ساخت حساب</button>
          <a href="#about"><FooterArt name="bar" />دربارهٔ مکعب</a>
          <a href="#contact"><FooterArt name="support" />تماس با ما</a>
          <button type="button" data-mokaab-install><FooterArt name="phone" />نصب مکعب</button>
        </nav>
        <div className="qcf-group qcf-connect" aria-labelledby="qcf-connect-title">
          <h2 id="qcf-connect-title"><FooterArt name="phone" size={32} />ارتباط با مکعب</h2>
          <div className="qcf-phone-row"><a href="tel:+982126618023" aria-label="تماس با فروشگاه: ۰۲۱ ۲۶۶۱ ۸۰۲۳"><FooterArt name="phone" /><bdi dir="ltr">۰۲۱ ۲۶۶۱ ۸۰۲۳</bdi></a><span>فروشگاه · روزهای کاری، ۱۰ تا ۲۰</span></div>
          <div className="qcf-mobile-contacts"><h3>کارشناسان فروش</h3><div>{SALES_MOBILES.map(number => <a key={number} href={`tel:+98${number.slice(1)}`} aria-label={`تماس با کارشناس فروش: ${phoneLabel(number)}`}><FooterArt name="phone" size={24}/><bdi dir="ltr">{phoneLabel(number)}</bdi></a>)}</div></div>
          <a href="mailto:info@mokaab.gold"><FooterArt name="receipt" /><bdi dir="ltr">info@mokaab.gold</bdi></a>
          <a href="https://mokaab.gold" target="_blank" rel="noopener noreferrer"><FooterArt name="bar" /><span>فروشگاه مکعب <small dir="ltr">mokaab.gold</small></span></a>
          <button type="button" className="qcf-support" onClick={onLogin}><FooterArt name="receipt" />ورود و پیگیری درخواست</button>
        </div>
      </div>
      <div className="qcf-address">
        <FooterArt name="location" size={40} />
        <div><strong>نشانی فروشگاه مکعب</strong><p>{STORE_ADDRESS}</p></div>
        <a href={MAP_URL} target="_blank" rel="noopener noreferrer"><FooterArt name="goal" />مسیریابی روی نقشه</a>
      </div>
      <div className="qcf-bottom"><p>© {year} مکعب. همهٔ حقوق این وب‌سایت محفوظ است.</p><button type="button" onClick={onAdmin}><FooterArt name="shield" size={24} />ورود مدیر</button></div>
    </div>
  </footer>;
}
